import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";


const WorkingHours = ({
  type,
  onChange,
  onDelete,
  disabled,
  value,
  title,
  error,
  children,
  provider_data,
  working_hours_data,
  removeItem,
  addNewItem,
  ...props
}) => {



const useStyles = makeStyles(theme => ({
	SwitchLabel: {
	'& .MuiFormControlLabel-label': {
	  fontSize: '0.75rem',
	},
	},
	formControl: {
		margin: theme.spacing(1),
		minWidth: 130,
		fontSize: '0.75rem',
	},
	typography: {
		color: 'rgba(0, 0, 0, 0.54)',
		padding: 0,
		fontSize: '1rem',
		fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
		fontWeight: 400,
		lineHeight: 1,
		transform: 'translate(0, 1.5px) scale(0.75)',
		transformOrigin: 'top left',
		letterSpacing: '0.00938em',
		transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
	}

	}));

  const handleChange = event => {
    onChange(event, 'working_hours_data')
  }

  const handleAddItem = event => {
    event.preventDefault();
    event.stopPropagation();
    addNewItem('working_hours_data');
  }

  const handleRemoveItem = (event, idx) =>{
    event.preventDefault();
    event.stopPropagation();
    removeItem('working_hours_data', idx)
  }


  const handleDelete = (type, value) => {

    if (disabled){
      return;
    }

    onDelete(type, value)
  }

  const onMouseDown = e => {
    e.stopPropagation();
  };

  const days = ['Domingo','Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sabado']

  const classes = useStyles();

	const ITEM_HEIGHT = 48;

	const ITEM_PADDING_TOP = 8;

	const MenuProps = {
	  PaperProps: {
	    style: {
	      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
	      width: 250,
	    },
	  },
	};

  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>
	  {working_hours_data.map((val,idx)=> {


	  	return (
		      <div className="row mt-1 ml-1">
		      	<FormControl className={classes.formControl} inputProps={{shrink: true}}><Typography className={classes.typography}>Días</Typography>
			        <Select
			          labelId="demo-mutiple-chip-label"
			          id={"day."+ idx}
			          name={"day."+ idx}
			          multiple
		              disabled={disabled}
					  value={val.day}
			          onChange={(e)=>{handleChange(e)}}
			          input={<Input id="select-multiple-chip" />}
			          renderValue={selected => (
			            <div className={classes.chips}>
			              {selected.map(value => (
			                <Chip key={value} label={value} className={classes.chip} onDelete={(provider_data.schedules !== undefined && provider_data.schedules !== null) ? (provider_data.schedules.find(o => o.day === days.indexOf(value))) ? (e)=>{handleDelete('schedules', value)} :false : ''} onMouseDown={(e)=>{onMouseDown(e)}} />
			              ))}
			            </div>
			          )}
			          MenuProps={MenuProps}
			        >
			          {days.map(day => (
			            <MenuItem key={day} data-id={day} dataid={day} id={day} value={day} >
			             <Checkbox className="pr-4" color="primary" checked={val.day.indexOf(day) > -1} style={{height: 0, width:0}}/>
			              {day}
			            </MenuItem>
			          ))}
			        </Select>
		    	</FormControl>
					<TextField
						id={"hour_from."+ idx}
						name={"hour_from."+ idx}
						label="Hora inicio"
						type="time"
						onChange={handleChange}
				        disabled={disabled}
						value={val.hour_from}
						className="mt-4 mr-2 "
						InputLabelProps={{
						  shrink: true
						}}
						inputProps={{
						  step: 300,
						  style:{fontSize: '0.75rem', width: 100} 
						}}
					/>
					<TextField
						id={"hour_to."+ idx}
						name={"hour_to."+ idx}
						label="Hora fin"
						type="time"
						onChange={handleChange}
						value={val.hour_to}
				        disabled={disabled}
						className="mt-4 mr-2 "
						InputLabelProps={{
						  shrink: true
						}}
						inputProps={{
						  step: 300, 
						  style:{fontSize: '0.75rem', width: 100}
						}}
					/>
              <div class="mt-4" style={{width:"min-content", display:"inline-flex"}}>   
                <IconButton size="small" className={classes.iconButton} onClick={(e)=> {handleRemoveItem(e, idx)}}
                disabled={(working_hours_data.length ==1) ? true : false} >
                  <RemoveIcon className={classes.deleteIcon} />
                </IconButton>
                <IconButton size="small" className={classes.iconButton} onClick={(e)=> {handleAddItem(e)}}>
                      <AddIcon className={classes.deleteIcon}/>
                </IconButton>
              </div>

			</div>

  		)
	  })}

      { error && <p>{ error }</p>}
    </React.Fragment>
  )
}

WorkingHours.defaultProps = {
  type: "text",
  className: "",
  disabled:false
}

WorkingHours.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  title: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default WorkingHours;

